export default () => ({
  candidates: [],
  results: [],
  campaignId: null
})
